/* 
import LayoutComp from './Components/LayoutComp';
import Login from './Pages/Auth/Login';
import './App.css'
import { useState, useEffect } from 'react';

function App() {
  const [isLoggedIn, setAuth] = useState(localStorage.getItem("auth"));

  useEffect(() => {
    setAuth(localStorage.getItem("auth") == null ? false : localStorage.getItem("auth"));
  }, []);


  return (
    <>


      {!isLoggedIn !=="false" ? <Login /> : <LayoutComp />}


    </>
  )
}

export default App;
 */
import LayoutComp from './Components/LayoutComp';
import Login from './Pages/Auth/Login';
import './App.css';
import { useState, useEffect } from 'react';
import LoadingPage from './Pages/LoadingPage';


function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const auth = localStorage.getItem("auth");
    setIsLoggedIn(auth === "true");
    setLoading(false);
  }, []);

  if (loading) {
    return <LoadingPage />; // Utiliser la page de chargement animée
  }

  return (
    <>
      {isLoggedIn ? <LayoutComp /> : <Login />}
    </>
  );
}

export default App;


